const CONVENE_TIME_URL =
  'https://apps.texastribune.org/data/85th-texas-legislature/convene-times.json';
const CAMERA_STATUS_URL =
  'https://apps.texastribune.org/data/85th-texas-legislature/camera-status.json';

const HOUSE_CAMERA_ID = 3;
const SENATE_CAMERA_ID = 12;

export {
  CAMERA_STATUS_URL,
  CONVENE_TIME_URL,
  HOUSE_CAMERA_ID,
  SENATE_CAMERA_ID,
};
